import { render, staticRenderFns } from "./OrdenPrelacion.vue?vue&type=template&id=48541ac3&"
import script from "./OrdenPrelacion.vue?vue&type=script&lang=js&"
export * from "./OrdenPrelacion.vue?vue&type=script&lang=js&"
import style0 from "./OrdenPrelacion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports